import ChatThreadExchangeDayHeading from './ChatThreadExchangeDayHeading.jsx'
import ChatThreadExchangeUserBlock from './ChatThreadExchangeUserBlock.jsx'

export default function ChatThreadExchangeQuestion({
  showDayDivider,
  query,
  exchangeId,
  calendarNow,
  edit,
  nav,
  focusedMessageId,
}) {
  if (!query.currentUser) return null
  return (
    <>
      {showDayDivider ? (
        <ChatThreadExchangeDayHeading
          createdAt={query.currentUser.createdAt}
          calendarNow={calendarNow}
        />
      ) : null}
      <ChatThreadExchangeUserBlock
        currentUser={query.currentUser}
        exchangeId={exchangeId}
        {...edit}
        queryActiveOrdinal={query.queryActiveOrdinal}
        queryCount={query.queryCount}
        queryCanPrev={query.queryCanPrev}
        queryCanNext={query.queryCanNext}
        onQueryPrev={nav.onQueryPrev}
        onQueryNext={nav.onQueryNext}
        focusedMessageId={focusedMessageId}
      />
    </>
  )
}
